import * as React from 'react'
import {memo, useCallback} from 'react'

import type {BuildType} from '../../../../services/rest'
import type {ProjectId} from '../../../../types'
import {SubprojectContext} from '../../../common/NestedSubprojectsAndBuildTypes/NestedSubprojectsAndBuildTypesContext'
import BuildProblemFilter from '../BuildProblems/BuildProblemFilter/BuildProblemFilter'

import NestedBuildTypeProblems from './NestedBuildTypeProblems.container'

type Props = {
  projectId: ProjectId
  // TODO Remove
  buildTypes?: BuildType[]
}

function BuildTypeProblems({projectId, buildTypes}: Props) {
  const nestedRender = useCallback(
    (nestedProjectId: ProjectId, level: number) => (
      <NestedBuildTypeProblems projectId={nestedProjectId} level={level} buildTypes={buildTypes} />
    ),
    [buildTypes],
  )

  return (
    <>
      <BuildProblemFilter projectId={projectId} />
      <SubprojectContext.Provider value={nestedRender}>
        <NestedBuildTypeProblems level={0} projectId={projectId} />
      </SubprojectContext.Provider>
    </>
  )
}
export default memo(BuildTypeProblems)
